import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleCheck } from 'lucide-react';
/**
 * 渲染带说明文本的单选列表（互动程度），每行左侧为单选标记、右侧为主标题与说明；
 * 选中行使用品牌描边与高亮底色，点击整行即完成选择。
 */
export function ProjectOptionList(props) {
    /** 当前选中编码，未选择时用空字符串参与比较。 */
    const selectedValue = props.value ?? '';
    return (_jsx("div", { className: "project-option-list", role: "radiogroup", "aria-label": props.ariaLabel, children: props.options.map((option) => {
            /** 当前行是否为选中项。 */
            const isSelected = option.value === selectedValue;
            return (_jsxs("button", { type: "button", role: "radio", "aria-checked": isSelected, className: `project-option-list__item${isSelected ? ' project-option-list__item--selected' : ''}`, onClick: () => {
                    props.onChange?.(option.value);
                }, children: [_jsx("span", { className: "project-option-list__marker", "aria-hidden": "true", children: isSelected ? _jsx(CircleCheck, {}) : null }), _jsxs("span", { className: "project-option-list__text", children: [_jsx("span", { className: "project-option-list__label", children: option.label }), option.description ? (_jsx("span", { className: "project-option-list__description", children: option.description })) : null] })] }, option.value));
        }) }));
}
